/* import __COLOCATED_TEMPLATE__ from './qa-assignee.hbs'; */
/* RESPONSIBLE TEAM: team-rd-services */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type Inbox2AssigneeSearch from 'embercom/services/inbox2-assignee-search';
import type AdminSummary from 'embercom/objects/inbox/admin-summary';

interface Signature {
  Args: {
    adminId?: number;
  };
}

export default class QaAssignee extends Component<Signature> {
  @service declare inbox2AssigneeSearch: Inbox2AssigneeSearch;

  get admin(): AdminSummary | undefined {
    let id = this.args.adminId;
    return id === undefined ? undefined : this.inbox2AssigneeSearch.findAdminById(id);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationsTable::TableCells::QaAssignee': typeof QaAssignee;
    'inbox2/conversations-table/table-cells/qa-assignee': typeof QaAssignee;
  }
}
